import {
    Collapse,
    Table,
    TableContainer,
    Tbody,
    Td,
    Text,
    Tfoot,
    Th,
    Tr
} from '@chakra-ui/react'
import { useState } from 'react'
import { storagePage } from '../../storage'
import Card from '../../Components/Card'
import StatBox from '../../Components/StatBox'
import StatCard from '../../Components/StatCard'
import ViewDetailButton from '../../Components/ViewDetailButton'

export default function CashboxSummary() {
    const [showDetail, setShowDetail] = useState(false)

    const { cashboxMovements } = storagePage

    const totalCash = cashboxMovements
        .map(i => i.summaryTotalCash)
        .reduce((a, b) => a + b, 0)

    const totalCardAndTipCard = cashboxMovements
        .map(i => i.paymentCardTotalValue + i.paymentTipWithCardTotalValue)
        .reduce((a, b) => a + b, 0)

    const totalTransfer = cashboxMovements
        .map(i => i.paymentTransferTotalValue)
        .reduce((a, b) => a + b, 0)

    const totalCashbox = totalCash + totalCardAndTipCard + totalTransfer

    return (
        <Card
            direction="column"
            gridGap={4}
            w={{ base: 'full', md: '49.5%', lg: '50%' }}
        >
            <Text as="b" mr="2" fontSize="xl" align="center" w="full">
                Resumen de caja
            </Text>
            <StatCard>
                <StatBox
                    label={'Total caja'}
                    value={totalCashbox.toFixed(2)}
                    withSymbol={true}
                />
            </StatCard>
            <ViewDetailButton
                showDetail={showDetail}
                setShowDetail={setShowDetail}
            />

            <Collapse in={showDetail}>
                <TableContainer>
                    <Table size="sm">
                        <Tbody>
                            <Tr>
                                <Td>Total efectivo</Td>
                                <Td isNumeric>{totalCash.toFixed(2)}</Td>
                            </Tr>
                            <Tr>
                                <Td>Total tarjeta</Td>
                                <Td isNumeric>
                                    {totalCardAndTipCard.toFixed(2)}
                                </Td>
                            </Tr>
                            <Tr>
                                <Td>Total Transferencia</Td>
                                <Td isNumeric>{totalTransfer.toFixed(2)}</Td>
                            </Tr>
                        </Tbody>
                        <Tfoot>
                            <Tr>
                                <Th>Total en Caja</Th>
                                <Th isNumeric>
                                    S/
                                    {totalCashbox.toFixed(2)}
                                </Th>
                            </Tr>
                        </Tfoot>
                    </Table>
                </TableContainer>
            </Collapse>
        </Card>
    )
}
